import Ajv2020 from "ajv/dist/2020";
import addFormats from "ajv-formats";
import { AnySchema, ValidateFunction } from "ajv";
import { createContext, FC, useContext } from "react";

export type AppSettingsSchema = Record<string, unknown>;

export type PreparedAppSettingsSchema = {
  schema: AppSettingsSchema;
  fullConfigValidator: ValidateFunction;
  conditionValidator: ValidateFunction;
};

type AppSettingsSchemaContextValue = PreparedAppSettingsSchema;

const AppSettingsSchemaContext =
  createContext<AppSettingsSchemaContextValue | null>(null);

export const prepareAppSettingsSchema = (
  schema: AppSettingsSchema,
): PreparedAppSettingsSchema => {
  const ajv = new Ajv2020({ allErrors: true });
  addFormats(ajv);

  const conditionSchema = {
    $schema: schema.$schema,
    $defs: schema.$defs,
    $ref: "#/$defs/Condition",
  } as AnySchema;

  return {
    schema,
    fullConfigValidator: ajv.compile(schema),
    conditionValidator: ajv.compile(conditionSchema),
  };
};

export const AppSettingsSchemaProvider: FC<{
  value: PreparedAppSettingsSchema;
}> = ({ children, value }) => (
  <AppSettingsSchemaContext.Provider value={value}>
    {children}
  </AppSettingsSchemaContext.Provider>
);

export const useAppSettingsSchemaContext = (): AppSettingsSchemaContextValue => {
  const value = useContext(AppSettingsSchemaContext);
  if (!value) {
    throw new Error(
      "useAppSettingsSchemaContext must be used within AppSettingsSchemaProvider",
    );
  }

  return value;
};
